import { Col } from "antd";

export const ItemCol = ({ item, isActiveHandlerItem, isActive }) => {
  return (
    <Col
      onClick={() => isActiveHandlerItem(item)}
      className={`item-lamp ${isActive ? "item-lamp-active" : ""}`}
      span={24}
    >
      <div className="item-lamp-inner">
        <span className={`item-lamp-dot ${item.isActive ? "item-lamp-dot--on" : "item-lamp-dot--off"}`} />
        <div className="item-lamp-text">
          <span className="item-lamp-name">{item.name}</span>
          <span className="item-lamp-eui">{item.devEui}</span>
        </div>
      </div>
    </Col>
  );
};
